import HeadCell from "@common/table/head/headCell"
import { TableHeadCellProps } from "@common/table/types"
import React from "react"

const TableHead = ({ table }: Omit<TableHeadCellProps, "header">) => {
  const {
    options: { themes },
  } = table
  return (
    <thead className={themes.tHeadStickyClasses} ref={table.refs.tableHeaderRef}>
      {table.getHeaderGroups().map((headerGroup) => (
        <tr
          key={headerGroup.id}
          // adding border right to each header cell except the last one
          className="table-row"
        >
          {headerGroup.headers.map((header) => {
            return <HeadCell key={header.id} header={header} table={table} />
          })}
        </tr>
      ))}
    </thead>
  )
}

export default TableHead
